import { css } from '@emotion/react';

const pricesTableStyles = css`
    .date-input {
        width: 100%;
        display: flex;

        .date-select {
            margin-right: 1rem;
        }

        label {
            font-size: 16px;
            font-weight: bold;
        }
    }
`;

export const pricesTableThemeStyles = css`
    .date-input {
        width: 100%;
        display: flex;
        background-color: var(--color-white);
        justify-content: space-around;

        .date-select {
            select {
                height: 45px;
                border: none;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
                background-color: #ffffff;
                padding: 0rem 0.5rem;
            }
        }

        button {
            background-color: var(--buttonComponent-primaryBackgroundColor);
            border-color: var(--buttonComponent-primaryBorderColor);
            border-style: var(--buttonComponent-borderStyle);
            border-width: var(--buttonComponent-borderWidth);
            font-size: var(--buttonComponent-fontSize);
            font-weight: var(--buttonComponent-fontWeight);
            font-family: var(--buttonComponent-fontFamily);
            line-height: var(--buttonComponent-lineHeight);
            padding: var(--buttonComponent-padding);
            border-radius: var(--buttonComponent-borderRadius);
            color: var(--buttonComponent-textColor);
        }

        label {
            font-family: var(--font-family-regular);
            color: var(--default-text-color);
            font-weight: var(--font-weight-bold);
            font-size: var(--font-size-regular);
        }
    }

    .download-all-button {
        background-color: var(--buttonComponent-primaryBackgroundColor);
        border-color: var(--buttonComponent-primaryBorderColor);
        border-style: var(--buttonComponent-borderStyle);
        border-width: var(--buttonComponent-borderWidth);
        font-size: var(--buttonComponent-fontSize);
        font-weight: var(--buttonComponent-fontWeight);
        font-family: var(--buttonComponent-fontFamily);
        line-height: var(--buttonComponent-lineHeight);
        padding: var(--buttonComponent-padding);
        border-radius: var(--buttonComponent-borderRadius);
        color: var(--buttonComponent-textColor);
    }

    .fa-sort-up {
        color: var(--color-green);
        font-size: var(--font-size-large);
    }

    .fa-sort-down {
        color: var(--color-red);
        font-size: var(--font-size-large);
    }
`;

export default pricesTableStyles;
